var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { number, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { clamp, isContentfulString } from '@philips-internal/oswald-ui-utils';
import ProgressBarAPI from './progress-bar-api.js';
import './progress-bar.css';
let ProgressBar = class ProgressBar extends Component {
    clampPercentage(value) {
        return clamp({ max: 100, min: 0, value });
    }
    calculatePercentage() {
        const { currentPart = 0, maxParts = 0, percentage = 0 } = this.props;
        if (percentage > 0) {
            return this.clampPercentage(percentage);
        }
        if (currentPart >= 0 && maxParts > 0) {
            const value = (currentPart / maxParts) * 100;
            return this.clampPercentage(value);
        }
        return 0;
    }
    renderTexts() {
        const { leftText, rightText } = this.props;
        if (!isContentfulString(leftText) && !isContentfulString(rightText)) {
            return null;
        }
        return (React.createElement("div", { className: "c-progress-bar__texts" },
            React.createElement("span", { className: "c-progress-bar__text u-hide@empty" }, leftText),
            React.createElement("span", { className: "c-progress-bar__text u-hide@empty" }, rightText)));
    }
    render() {
        const percentage = this.calculatePercentage();
        return (React.createElement("div", { className: "c-progress-bar" },
            this.renderTexts(),
            React.createElement("div", { className: "c-progress-bar__back-bar" },
                React.createElement("div", { className: "c-progress-bar__percentage", style: { width: `${percentage}%` } }))));
    }
};
ProgressBar.propTypes = {
    currentPart: number,
    leftText: string,
    maxParts: number,
    percentage: number,
    rightText: string,
};
ProgressBar = __decorate([
    AwesomeComponent({ api: ProgressBarAPI, type: ComponentType.DATA_DISPLAY })
], ProgressBar);
export { ProgressBar, };
//# sourceMappingURL=progress-bar.js.map